module.exports = __webpack_public_path__ + "static/media/bliss-preto.3ae65177.jpg";